<template>
  <div :id="'chart' + this.uniqueId"></div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
import am4themes_material from "@amcharts/amcharts4/themes/material";
export default {
  components: {},
  props: {
    data: { type: Array },
    headingColumn: { type: String, default: "" },
    dataColumn: { type: String, default: "" },
    series: { type: Array, default: [] },
    showLegend: { type: Boolean, default: true },
  },
  data: function () {
    return { chart: null, uniqueId: Math.random().toFixed(2) };
  },
  methods: {
    GenerateChart(ID) {
      am4core.useTheme(am4themes_material);

      this.chart = am4core.create(ID, am4charts.XYChart);

      this.chart.data = this.data;

      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = this.headingColumn;
      categoryAxis.renderer.minGridDistance = 60;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.rotation = -25;

      categoryAxis.renderer.labels.template.adapter.add("dy", function (dy, target) {
        if (target.dataItem && target.dataItem.index & (2 == 2)) {
          return dy + 0;
        }
        return dy;
      });

      let label = categoryAxis.renderer.labels.template;
      label.truncate = false;
      label.tooltipText = `{category}`;
      label.fontSize = 10;
      label.fontWeight = 100;
      label.stroke = new am4core.color("#9d9d9d");

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.baseValue = 0;

      this.chart.cursor = new am4charts.XYCursor();

      for (const series of this.series) {
        let tmpSeries = this.chart.series.push(new am4charts.LineSeries());
        tmpSeries.dataFields.valueY = series.dataColumn;
        tmpSeries.dataFields.categoryX = series.headingColumn;
        tmpSeries.strokeWidth = 4;
        tmpSeries.tensionX = 0.99;
        tmpSeries.name = series.dataColumn;
        tmpSeries.tooltipText = "{name}: [bold]{valueY}[/]";
        tmpSeries.stroke = am4core.color(series.color);

        var bullet = tmpSeries.bullets.push(new am4charts.CircleBullet());
        bullet.fill = new am4core.InterfaceColorSet().getFor("background");
        bullet.fillOpacity = 1;
        bullet.strokeWidth = 2;
        bullet.circle.radius = 4;
      }

      if (this.showLegend) {
        this.chart.legend = new am4charts.Legend();
        this.chart.legend.valueLabels.template.align = "left";
        this.chart.legend.valueLabels.template.textAlign = "end";
      }
    },
    UpdateChartData() {
      this.chart.data = this.data;
      this.chart.validateData();
      this.chart.series.clear();

      for (const series of this.series) {
        let tmpSeries = this.chart.series.push(new am4charts.LineSeries());
        tmpSeries.dataFields.valueY = series.dataColumn;
        tmpSeries.dataFields.categoryX = series.headingColumn;
        tmpSeries.strokeWidth = 4;
        tmpSeries.tensionX = 0.57;
        tmpSeries.name = series.dataColumn;
        tmpSeries.tooltipText = "{name}: [bold]{valueY}[/]";
        tmpSeries.stroke = am4core.color(series.color);

        var bullet = tmpSeries.bullets.push(new am4charts.CircleBullet());
        bullet.fill = new am4core.InterfaceColorSet().getFor("background");
        bullet.fillOpacity = 1;
        bullet.strokeWidth = 2;
        bullet.circle.radius = 4;
      }
    },
  },
  mounted() {
    this.GenerateChart("chart" + this.uniqueId);
  },
  beforeDestroy() {
    this.chart.dispose();
  },
  watch: {
    data: function () {
      this.UpdateChartData();
    },
  },
};
</script>

<style></style>
